module.exports = __webpack_public_path__ + "img/jftw.7444b5db.svg";